import {
  Dialog,
  DialogActionsBar,
  type DialogProps,
} from '@progress/kendo-react-dialogs'
import { Loader } from '@progress/kendo-react-indicators'
import classNames from 'classnames'
import React from 'react'

import { LoadingPanel } from '~/components/elements/LoadingPanel'

import styles from './SuspenseDialog.css'

export type SuspenseDialogProps = DialogProps & {
  actions?: React.ReactNode
  'data-testid'?: string
  executing?: boolean
  loading?: boolean
}

export const SuspenseDialog = ({
  actions,
  children,
  className,
  'data-testid': dataTestId = 'components-elements-suspense-dialog',
  executing = false,
  loading = false,
  ...rest
}: SuspenseDialogProps) => (
  <Dialog
    className={classNames(
      styles.root,
      {
        [styles.loading]: loading,
        [styles.executing]: executing,
      },
      className,
    )}
    data-testid={dataTestId}
    {...rest}
  >
    {loading ? <LoadingPanel /> : children}

    {executing && <Loader className={styles.loader} type="infinite-spinner" />}

    {!loading && actions && <DialogActionsBar>{actions}</DialogActionsBar>}
  </Dialog>
)
